import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getTabsSelector } from './selectors';
import { PageContentWithNav } from '../../components/page-content-with-nav';
import ReqsMineContainer from '../reqs-mine';

const ReqsCargoContainerWrapper = ({ tabs }) => {
	const { pathname } = useLocation();

	const currentTab = pathname.split('/')[2];

	const filteredTabs = tabs.filter(tab => tab.href.includes(currentTab));

	return <PageContentWithNav pageNavigationItems={filteredTabs} pageContent={<ReqsMineContainer />} />;
};

ReqsCargoContainerWrapper.propTypes = {
	tabs: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = createStructuredSelector({
	tabs: getTabsSelector(),
});

const ReqsCargoContainer = connect(mapStateToProps)(ReqsCargoContainerWrapper);

export default ReqsCargoContainer;
